<template>
    <div>
        <div
            class="relative flex flex-row  w-full items-center align-baseline transition-all ease-in-out duration-1000"
            :class="{ 'bg-blue-20 shadow-1dp' : isSelecting }"
        >
            <product-field-info
                :field="field"
                :isSelecting="isSelecting"
                :selected="selected"
                :selectedDisplayName="formatSelectedName"
                :position="position"
                :total="total"
                :isMobileView="isMobileView"
                :showDescription="showSideBarDescription"
                :disabled="disabled"
                @ShowLearMore="ShowLearMore"
                @HideLearMore="HideLearMore"
            />

            <span class="configurator-field-line" v-show="!isSelecting && !selected"></span>
            
            <div class="hidden lg:block w-full order-3 mr-4 | md:order-2 md:w-auto md:flex-1">
                <div class="flex items-center">
                    <SelectInput :options="getVisibleFields(field.options)"
                                 :value="selectedIndex"
                                 @change="changed"
                                 :disabled="disabled"
                                 class="transition-all duration-1000"
                                 :class="{'mt-6': isSelecting, 'selecting': isSelecting }"
                    />
                    <div class="flex flex-col ml-2.5 min-w-[61px]">
                        <div
                            class="btn-info block mb-1.5 max-w-fit last:mb-0"
                            role="button"
                            style="transition: margin 1s ease;"
                            :class="{'mt-6': isSelecting }"
                            @click="ShowLearMore"
                        >
                            <icon-plus class=""/>
                            <span>Info</span>
                        </div>
                        
                        <a v-if="field.video" target="_blank" :href="field.video" class="btn-info block">
                            <icon-play/>
                            <span>Video</span>
                        </a>
                    </div>
                </div>
            </div>

            <div class="flex flex-col items-end w-full mr-[20px] lg:hidden">
                <div class="flex flex-col" v-if="disabled">
                    <div
                        v-if="hasDescriptions"
                        class="btn-info mb-2 last:mb-0"
                        @click="ShowLearMore"
                    >
                        <icon-plus class=""/>
                        <span>Info</span>
                    </div>
                    
                    <a v-if="field.video" target="_blank" :href="field.video" class="btn-info block">
                        <icon-play/>
                        <span>Video</span>
                    </a>
                </div>

                <div v-show="!disabled" class="mt-8">
                    <select-button :clicked="showMobileSelect" :selected="selected"></select-button>
                </div>
            </div>

            <MountingPortal append mountTo="#configurator-field-menu" multiple>
                <MobileSelect
                    :show="mobileSelect" @close="hideMobileSelect"
                    :title="field.label + ' options'"
                    background="bg-blue-20"
                >
                    <div class="flex flex-col items-stretch pt-4 overflow-y-auto h-[calc(100%-140px)]">
                        <button
                            v-for="(field,index) in getVisibleFields(field.options)"
                            class="px-5 py-3 text-4 text-darkblue-800 text-left"
                            :class="{ 'bg-blue !text-white' : mobileSelectOption === index || (selectedIndex == index && mobileSelectOption === null) }"
                            @click="selectMobileOption(index)"
                        >{{ field.label }} {{ Number(field.getPricePerType()) > 0 ? `- $${field.getPricePerType()} ${field.getTypeLabel()}` : '' }}
                        </button>
                    </div>

             
                    <div class="px-5">
                        <button
                            class="btn btn--primary btn--big w-full"
                            :class="{ 'btn--disable' : mobileSelectOption === null  }"
                            :disabled="mobileSelectOption === null"
                            @click="selectOption(mobileSelectOption)"
                        >
                            <span>Confirm your selection</span>
                        </button>
                    </div>
                </MobileSelect>
            </MountingPortal>

        </div>
    </div>
</template>

<script>
import IconInfo from "../Icons/IconInfo";
import ProductFieldInfo from "../helpers/ProductFieldInfo";
import SelectButton from "../helpers/SelectButton";
import MobileSelect from "../MobileSelect";
import IconPlus from "../Icons/IconPlus.vue";
import DropDown from "../../../../../assets/js/vue/icons/drop-down.vue";
import SelectInput from "../SelectInput.vue";
import IconPlay from "../Icons/IconPlay.vue";

export default {
    name: "ProductField",
    components: {
        IconPlay,
        SelectInput,
        DropDown,
        IconPlus,
        MobileSelect,
        SelectButton,
        ProductFieldInfo,
        IconInfo
    },
    props: {
        field: {},
        sizes: {},
        total: 0,
        position: 0,
        fieldDisplayPrice: 0,
        showMinPrice: {
            default: false,
        },
        selected: {
            default: null
        },
        disabled: {
            default: true
        },
        fieldUpdated: {
            type: Function,
            default: () => {}
        },
        conditionController: {}
    },
    created() {
        this.onResize();
        window.addEventListener("resize", this.onResize);
    },
    destroyed() {
        window.removeEventListener("resize", this.onResize);
    },
    data() {
        return {
            mobileSelect: false,
            mobileSelectOption: null,
            showSideBarDescription: false,
            selecting: this.selected,
            selectedIndex: null,
            innerWidth: window.innerWidth,
            isMobileView: false,
        }
    },
    watch: {
        selected(newValue) {
            if (!newValue) {
                this.selectedIndex = null
            }
        }
    },
    computed: {
        canBeEdited(){
            return this.field.selectedOption !== null || this.isSelecting
        },
        isSelecting() {
            return this.showDescription;
        },
        showDescription() {
            return !this.disabled && !this.field.selectedOption
        },
        showSelect() {
            return !this.field.selectedOption || this.edit
        },
        selectedPrice() {

            if (!this.selected) {
                return ''
            }

            if (!this.showMinPrice) {
                return '';
            }

            if (this.fieldDisplayPrice <= 0) {
                return false;
            }

            return this.fieldDisplayPrice;//PriceCalculator.roundUp(this.selected.getPrice(this.sizes), 2).toFixed(2)
        },
        hasDescriptions() {
          return this.field.info ?? false;
            // return this.field.options?.filter(item => {
            //     return item.description.text !== '';
            // }).length ?? false;
        },
        formatSelectedName() {
            return this.selected?.label ?? '';
        },
        
    },
    methods: {
        selectMobileOption(index) {
            this.mobileSelectOption = index
        },
        showMobileSelect() {
            if(this.canBeEdited){
                this.mobileSelect = true;
                this.mobileSelectOption = null;
            }
        },
        hideMobileSelect() {
            this.mobileSelect = false;
            this.mobileSelectOption = null;
        },
        ShowLearMore() {
            this.showSideBarDescription = true;
        },
        HideLearMore() {
            this.showSideBarDescription = false;
        },
        changed(e) {
            this.selectOption(e);
        },
        selectOption(index) {
            this.field.selectedOption = this.getVisibleFields(this.field.options)[index];

            this.selectedIndex = index;
            this.mobileSelectOption = null;
            this.hideMobileSelect()

            this.field.mapToForm = this.mapToForm();
            this.fieldUpdated();
        },
        getVisibleFields(fields) {
            return fields.filter(field => {
                return this.conditionController.isFieldOptionShouldBeDisplayed(field);
            });
        },
        editField() {
            this.selecting = null;
            this.field.selectedOption = false;
            this.field.mapToForm = this.mapToForm();
        },
        mapToForm() {
            return {
                id: this.field.id,
                name: this.field.name,
                label: this.field.label,
                selected: this.field.selectedOption
            }
        },
        onResize(e) {
            this.innerWidth = window.innerWidth

            this.isMobileView = this.innerWidth < 1024;
        }
    },
}
</script>